(() => {
  'use strict';

  const popup = document.querySelector('[data-abb-bte-popup]');
  if (!popup) return;

  const dialog = popup.querySelector('[data-abb-bte-dialog]');
  const closeButton = popup.querySelector('[data-abb-bte-close]');
  const storageKey = 'abb-butterfly-effect-popup-last-shown-v1';
  const forcePreview = new URLSearchParams(window.location.search).get('show_butterfly_popup') === '1';
  const currentPath = window.location.pathname;
  let previousActiveElement = null;
  let hideTimer = null;

  if (currentPath !== '/') return;

  const getLocalDateKey = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  try {
    if (!forcePreview && window.localStorage.getItem(storageKey) === getLocalDateKey()) return;
  } catch (error) {
    // The popup remains functional when storage is unavailable.
  }

  const focusableElements = () => Array.from(
    popup.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
  ).filter((element) => element.offsetParent !== null);

  const rememberShownToday = () => {
    if (forcePreview) return;
    try {
      window.localStorage.setItem(storageKey, getLocalDateKey());
    } catch (error) {
      // Ignore storage errors.
    }
  };

  const openPopup = () => {
    previousActiveElement = document.activeElement;
    window.clearTimeout(hideTimer);
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('abb-bte-popup-open');
    rememberShownToday();

    window.requestAnimationFrame(() => {
      popup.classList.add('abb-bte-popup--visible');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  };

  const closePopup = () => {
    if (popup.hidden) return;
    popup.classList.remove('abb-bte-popup--visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('abb-bte-popup-open');

    hideTimer = window.setTimeout(() => {
      popup.hidden = true;
      if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus({ preventScroll: true });
      }
    }, 230);
  };

  popup.addEventListener('click', (event) => {
    const closeTarget = event.target instanceof Element
      ? event.target.closest('[data-abb-bte-close]')
      : null;
    if (closeTarget) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (event.key !== 'Tab' || !dialog) return;

    const focusable = focusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.setTimeout(openPopup, forcePreview ? 120 : 900);
})();
